var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c("div", { class: _vm.marketingItemClasses }, [
    _c("div", { staticClass: "upsell-marketing-item__text" }, [
      _c(
        "div",
        { staticClass: "upsell-marketing-item__text-label" },
        [
          _c("p", { staticClass: "typographies-paragraph-medium-regular" }, [
            _vm._v("\n                " + _vm._s(_vm.label) + "\n            ")
          ]),
          _vm._v(" "),
          _c(
            "CompassTooltip",
            {
              attrs: {
                content: _vm.tooltipText,
                "content-class": "tooltipUpsellMarketingItem"
              }
            },
            [
              _c("CompassIcon", {
                attrs: {
                  icon: "info-circle-fill",
                  size: "small",
                  type: "secondary"
                }
              })
            ],
            1
          )
        ],
        1
      ),
      _vm._v(" "),
      _vm.description.length > 0
        ? _c(
            "p",
            {
              staticClass:
                "upsell-marketing-item__text-description typographies-paragraph-small-regular"
            },
            [_vm._v("\n            " + _vm._s(_vm.description) + "\n        ")]
          )
        : _vm._e()
    ]),
    _vm._v(" "),
    _c(
      "div",
      { staticClass: "upsell-marketing-item__choice" },
      [
        !_vm.enabled
          ? _c(
              "CompassTooltip",
              {
                attrs: {
                  content: _vm.$t.__(
                    "pages.account.upsell.marketing.ChargebeeUpsellMarketingItem.option_not_available"
                  ),
                  "content-class": "tooltipUpsellMarketingItem"
                }
              },
              [
                !_vm.enabled
                  ? _c("CompassFeatureBadge", {
                      attrs: {
                        "is-interactive": false,
                        size: "small",
                        variant: "upsell"
                      }
                    })
                  : _vm._e()
              ],
              1
            )
          : _vm._e(),
        _vm._v(" "),
        _vm._t("default"),
        _vm._v(" "),
        _c("p", { staticClass: "upsell-marketing-item__price" }, [
          _c(
            "span",
            { staticClass: "typographies-paragraph-medium-semibold" },
            [
              _vm._v(
                "\n                " +
                  _vm._s(
                    _vm._f("numberformatCurrency")(
                      _vm.humanizeCentsPrice(_vm.amount)
                    )
                  ) +
                  "\n            "
              )
            ]
          ),
          _vm._v(" "),
          _c("span", { staticClass: "typographies-paragraph-medium-regular" }, [
            _vm._v(
              "\n                /" +
                _vm._s(_vm.recurrencyLabel(_vm.getRecurrence)) +
                "\n            "
            )
          ])
        ])
      ],
      2
    )
  ])
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }